import {Text} from 'native-base';
import React from 'react';

export interface PRSubtitleProps {
  children: string | string[] | React.ReactNode;
}

const PRSubtitle: React.FC<PRSubtitleProps> = ({children}) => {
  return (
    <Text fontSize="14px" lineHeight="18px" fontFamily="heading">
      {children}
    </Text>
  );
};

export default PRSubtitle;
